(() => {
  const componentName = 'yellowcart-collection-seo-disclosure';
  if (customElements.get(componentName)) return;

  class YellowcartCollectionSeoDisclosure extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-yc-seo-content]');
      this.toggle = this.querySelector('[data-yc-seo-toggle]');
      this.toggleWrap = this.querySelector('[data-yc-seo-toggle-wrap]');
      this.label = this.querySelector('[data-yc-seo-toggle-label]');
      if (!this.content || !this.toggle || !this.toggleWrap) return;

      this.expandLabel = this.dataset.expandLabel || 'Meer bekijken';
      this.collapseLabel = this.dataset.collapseLabel || 'Minder bekijken';
      this.expanded = false;
      this.userToggled = false;
      this.resizeTimer = null;
      this.frameId = null;

      this.handleToggle = (event) => {
        event.preventDefault();
        this.userToggled = true;
        this.setExpanded(!this.expanded);
      };

      this.handleResize = () => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.scheduleEvaluation(), 120);
      };

      this.toggle.addEventListener('click', this.handleToggle);
      window.addEventListener('resize', this.handleResize, { passive: true });

      this.scheduleEvaluation();

      if (document.fonts?.ready) {
        document.fonts.ready.then(() => {
          if (this.isConnected) this.scheduleEvaluation();
        });
      }
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.handleToggle);
      window.removeEventListener('resize', this.handleResize);
      window.clearTimeout(this.resizeTimer);
      if (this.frameId) window.cancelAnimationFrame(this.frameId);
    }

    scheduleEvaluation() {
      if (this.frameId) window.cancelAnimationFrame(this.frameId);
      this.frameId = window.requestAnimationFrame(() => {
        this.frameId = window.requestAnimationFrame(() => {
          this.frameId = null;
          if (this.isConnected) this.evaluate();
        });
      });
    }

    getCollapsedHeight() {
      const root = this.closest('.yc-type-collection-seo') || this;
      const styles = getComputedStyle(root);
      const variable = window.matchMedia('(max-width: 740px)').matches
        ? '--yc-collection-seo-collapsed-height-mobile'
        : '--yc-collection-seo-collapsed-height-desktop';
      return parseFloat(styles.getPropertyValue(variable)) || 320;
    }

    getNaturalSingleColumnHeight() {
      const properties = [
        'maxHeight',
        'overflow',
        'columnCount',
        'webkitColumnCount',
        'maskImage',
        'webkitMaskImage'
      ];
      const previous = {};

      properties.forEach((property) => {
        previous[property] = this.content.style[property];
      });

      this.content.style.maxHeight = 'none';
      this.content.style.overflow = 'visible';
      this.content.style.columnCount = '1';
      this.content.style.webkitColumnCount = '1';
      this.content.style.maskImage = 'none';
      this.content.style.webkitMaskImage = 'none';

      const height = this.content.scrollHeight;

      properties.forEach((property) => {
        this.content.style[property] = previous[property];
      });

      return height;
    }

    evaluate() {
      const needsCollapse = this.getNaturalSingleColumnHeight() > this.getCollapsedHeight() + 24;

      this.classList.toggle('is-collapsible', needsCollapse);
      this.toggleWrap.hidden = !needsCollapse;

      if (!needsCollapse) {
        this.userToggled = false;
        this.setExpanded(true);
        return;
      }

      this.setExpanded(this.userToggled ? this.expanded : false);
    }

    setExpanded(expanded) {
      this.expanded = expanded;
      this.classList.toggle('is-expanded', expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      if (this.label) this.label.textContent = expanded ? this.collapseLabel : this.expandLabel;
    }
  }

  customElements.define(componentName, YellowcartCollectionSeoDisclosure);
})();
